module.exports = __webpack_public_path__ + "static/assets/d4beab09bea7b09a70189605fd5a971c.svg";